import React from 'react';
import { useAsync } from 'react-use';
import { useDispatch, useSelector } from 'react-redux';

import utils from 'utils';
import services from 'services';
import actions from 'state/actions';
import selectors from 'state/selectors';

import CommonButton from 'components/Buttons/CommonButton';
import { actionType } from 'utils/constants';
import useCheckBeforeAction from '../hooks';

const ConnectJies = () => {
  const t = utils.intl.useTranslator();
  const dispatch = useDispatch();
  const isJiesRunning = useSelector(selectors.documents.selectIsJiesRunning);
  const engineInfo = useSelector(selectors.documents.selectEngineInfo);
  const records = useSelector(selectors.documents.selectAllActiveDocuments);
  const { checkDocuments } = useCheckBeforeAction(actionType.CONNECT_JIES);
  useAsync(async () => {
    const docFree = await checkDocuments();
    if (!docFree) return;
    try {
      const { data } = await services.getEngineInfo();
      dispatch(actions.documents.setEngineInfo(data));
    } catch (e) {
      console.error(e);
    }
  }, []);

  useAsync(async () => {
    if (engineInfo) {
      try {
        await services.isJiesRunning(engineInfo.clientPort);
        dispatch(actions.documents.setIsJiesRunning('green'));
      } catch (e) {
        dispatch(actions.documents.setIsJiesRunning('red'));
        console.error(e);
      }
    }
  }, [engineInfo]);

  const connectJies = () => {
    if (engineInfo) {
      if (isJiesRunning === 'green') {
        services.killJies(engineInfo.clientPort);
        dispatch(actions.documents.setIsJiesRunning('red'));
      } else {
        dispatch(actions.documents.setIsJiesRunning('yellow'));
        window.open(engineInfo.urlToCall);
        setTimeout(async () => {
          try {
            await services.isJiesRunning(engineInfo.clientPort);
            dispatch(actions.documents.setIsJiesRunning('green'));
          } catch (e) {
            utils.app.notify('fail', e as Error);
            console.error(e);
          }
        }, 50000);
      }
    }
  };

  const getJiesStatus = () => {
    switch (isJiesRunning) {
      case 'red':
        return t('connect_jies');
      case 'yellow':
        return t('trying_to_connect_jies');
      case 'green':
        return t('jies_is_running');
    }
  };

  const getIcons = () => {
    switch (isJiesRunning) {
      case 'red':
        return 'connect';
      case 'yellow':
        return 'isConnecting';
      case 'green':
        return 'disconnect';
    }
  };

  return (
    <CommonButton
      id="connect-jies-btn"
      action={connectJies}
      scope="tertiary"
      disabled={
        isJiesRunning === 'yellow' ||
        (isJiesRunning === 'red' && !utils.user.isActionEnabled(records, actionType.CONNECT_JIES))
      }
      value={getJiesStatus()}
      customIcon={getIcons()}
    />
  );
};

export default ConnectJies;
